<template>
  <div class="reviewHDDT mb-4">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="@/assets/img/Nextpay-logo-white.svg" alt="" /></a>
      </div>
    </div>
    <!-- Main -->
    <div class="main">
      <div v-if="dataContract" class="contract" style="padding: 10px 20px !important">
        <Header groupService="PAYMENT"></Header>
        <p class="txt-tranf txt-center fonsize-18">
          <b>CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM</b>
        </p>
        <p class="txt-tranf txt-center fonsize-20">
          <b>ĐIỀU KIỆN VÀ ĐIỀU KHOẢN SỬ DỤNG</b> <br />
          <b>DỊCH VỤ THANH TOÁN BẰNG MÃ VIETQR </b>
        </p>
        <div class="txt-center">(Ngày hiệu lực: <mark>...............</mark>)</div>
        <div>
          <b style="font-style: italic">ĐIỀU 1. PHẠM VI ÁP DỤNG </b>
          <div style="padding-left: 40px">
            <ul>
              <li>
                Merchant được xem là đã chấp nhận và đồng ý với tất cả các nội dung dưới đây khi xác
                nhận đồng ý qua phương tiện điện tử về việc đăng ký sử dụng Dịch vụ thanh toán bằng
                mã VietQR trên phần mềm quản lý của PosApp.
              </li>
              <li>
                Merchant cần đọc và hiểu Điều kiện và điều khoản sử dụng dịch vụ thanh toán bằng mã
                VietQR (“Điều kiện và điều khoản”) để hiểu Dịch vụ, sử dụng Dịch vụ theo đúng quy
                định của Công ty Cổ phần Công nghệ Vi Mô.
              </li>
            </ul>
          </div>
          <b style="font-style: italic">ĐIỀU 2. GIẢI THÍCH THUẬT NGỮ </b>
          <div style="padding-left: 40px">
            <ol>
              <li>
                1. <b>“PosApp”</b>: Là phần mềm quản lý do Công ty Cổ phần Công nghệ PosApp cung cấp
                cho Merchant
              </li>
              <li>2. <b>“Vi Mô”</b>: là Công ty Cổ phần Công nghệ Vi Mô</li>
              <li>3. <b>“mPOS”</b>: là một sản phẩm của Công ty Cổ phần Công nghệ Vi Mô</li>
              <li>
                4. <b>“Merchant”</b>: Là các tổ chức, đơn vị hoặc cá nhân có tài khoản thanh toán
                tại Ngân hàng, đăng ký Dịch vụ thanh toán bằng mã VietQR của mPOS trên nền tảng của
                PosApp
              </li>
              <li>
                5. <b>“Tài Khoản”/ “Tài Khoản Thanh Toán”</b>: Là tài khoản tiền gửi thanh toán bằng
                đồng Việt Nam của Merchant mở tại các Ngân hàng tại Việt Nam, được liên kết với Tài
                khoản định danh, do mPOS quản lý, được sử dụng để nhận tiền/sử dụng Dịch vụ do mPOS
                cung cấp.
              </li>
              <li>
                6. <b>Dịch vụ thanh toán bằng mã VietQR</b>: là dịch vụ thanh toán do mPOS cung cấp
                để xử lý các lệnh và ủy quyền thanh toán của Merchant, theo đó hỗ trợ Merchant thực
                hiện thanh toán hóa đơn, hàng hóa/dịch vụ trên các kênh giao dịch của Merchant bằng
                hình thức quét mã QR thông qua ứng dụng Mobile Banking của các Ngân hàng.
              </li>
              <li>
                7. <b>VietQR</b>: là nhận diện thương hiệu chung dành cho các dịch vụ thanh toán,
                chuyển khoản bằng mã QR được xử lý qua mạng lưới NAPAS và các ngân hàng thành viên,
                các trung gian thanh toán, các đối tác thanh toán trong và ngoài nước
              </li>
            </ol>
          </div>
          <b style="font-style: italic">ĐIỀU 3. ĐẶC ĐIỂM DỊCH VỤ THANH TOÁN BẰNG MÃ VIETQR</b>
          <div style="padding-left: 40px">
            <ol class="custom-list">
              <li>
                - Merchant có thể thông qua phần mềm PosApp, gửi yêu cầu tới mPOS tạo mã VietQR
                thanh toán theo từng hoá đơn, kiểm tra trạng thái giao dịch, hoàn tiền giao dịch….
              </li>
              <li>
                - Merchant có thể hiển thị mã QR để người mua hàng sử dụng App ngân hàng, ví điện tử
                quét QR thanh toán đơn hàng.
              </li>
              <li>
                - Merchant được ghi có số tiền người mua thanh toán thành công về tài khoản thanh
                toán của Merchant đã đăng ký với mPOS
              </li>
              <li>
                - mPOS gửi thông tin kết quả giao dịch cho PosApp để PosApp đồng bộ trạng thái và
                đối khớp giao dịch của Merchant trên PosApp.
              </li>
              <li>
                - Thuận tiện theo dõi trạng thái đơn hàng cùng giao dịch thanh toán ngay trên nền
                tảng của PosApp
              </li>
              <li>- Phí dịch vụ: Áp dụng theo biểu phí của mPOS từng thời kỳ.</li>
            </ol>
          </div>
          <b style="font-style: italic">ĐIỀU 4. QUYỀN LỢI VÀ TRÁCH NHIỆM CỦA MERCHANT</b>
          <div style="padding-left: 50px">
            <p class="txt-bold">1. Quyền của Merchant:</p>
            <ul class="custom-list">
              <li>
                Được Vi Mô thanh toán đầy đủ và đúng hạn giá trị trên giao dịch thành công sau khi
                đã trừ đi một khoản phí (nếu có) với các giao dịch thanh toán qua mã VietQR theo quy
                định tại Điều khoản và điều kiện này
              </li>
              <li>
                Được hiển thị các thông tin về trạng thái thanh toán của đơn hàng trên nền tảng
                PosApp.
              </li>
              <li>Được đăng ký hoặc huỷ dịch vụ thanh toán bằng mã VietQR trên nền tảng PosApp.</li>
            </ul>
            <p class="txt-bold">2. Trách nhiệm của Merchant</p>
            <ul class="custom-list">
              <li>
                Bằng việc đăng ký sử dụng Dịch vụ thanh toán bằng mã VietQR trên nền tảng PosApp,
                Merchant đồng ý cho PosApp tiếp nhận và xử lý giao dịch thanh toán qua mã VietQR và
                thông tin trạng thái giao dịch từ mPOS cho mục đích để PosApp cung cấp các tính năng
                phần mềm thuận tiện thực hiện thanh toán hoá đơn, hàng hoá/dịch vụ và theo dõi trạng
                thái đơn hàng ngay trên nền tảng của PosApp dựa trên Điều kiện & Điều khoản này.
              </li>
              <li>
                Merchant tuân thủ theo quy định và hướng dẫn của Vi Mô bao gồm nhưng không giới hạn
                về: thực hiện các bước thanh toán giao dịch, xử lý các giao dịch đặc biệt và các
                hướng dẫn, thông báo của Vi Mô bằng văn bản theo từng thời kỳ và tuân thủ các quy
                định của pháp luật.
              </li>
              <li>
                Merchant chịu trách nhiệm về tính hợp pháp, hợp lệ của hàng hóa, dịch vụ; đảm bảo
                hoạt động kinh doanh, cung ứng hàng hóa, dịch vụ là hợp pháp tại Việt Nam; thực hiện
                đầy đủ các thủ tục thông báo, đăng ký với cơ quan Nhà nước có thẩm quyền theo quy
                định pháp luật.
              </li>
              <li>
                Merchant phải thực hiện bồi thường cho Vi Mô giá trị thiệt hại phát sinh trực tiếp
                hay gián tiếp, bao gồm cả nghĩa vụ thanh toán mà Vi Mô phải thực hiện đối với bên
                thứ ba nếu tổn thất xảy ra là do lỗi của Merchant không tuân thủ đúng các quy định,
                hướng dẫn.
              </li>
              <li>
                Cho phép mPOS hiển thị thông tin trạng thái giao dịch trên tài khoản Merchant đã
                đăng ký trên nền tảng PosApp.
              </li>
              <li>
                Giữ bí mật các thông tin cá nhân, mã Khách hàng/tên đăng nhập, mật mã truy cập Dịch
                vụ trên nền tảng PosApp và mPOS, không cung cấp, tiết lộ cho bất kỳ bên thứ ba nào
                khác.
              </li>
              <li>
                Đồng ý rằng bất cứ hành động thực hiện truy cập vào nền tảng của PosApp, mPOS
                và/hoặc thực hiện giao dịch Tài khoản đăng nhập và Mật khẩu để thực hiện giao dịch
                đăng ký/hủy đăng ký Dịch vụ đều được xem là do chính Merchant thực hiện và Merchant
                hoàn toàn chịu trách nhiệm về hành động đó.
              </li>
              <li>
                Merchant cam kết không có các hành vi rửa tiền, tài trợ khủng bố trợ giúp cho các
                hành vi rửa tiền, tài trợ khủng bố hoặc các hành vi vi phạm quy định kiểm soát các
                giao dịch đáng ngờ theo quy định của pháp luật Việt Nam.
              </li>
              <li>
                Đồng ý với Biểu phí Dịch vụ thanh toán bằng mã VietQR khi sử dụng Dịch vụ (bao gồm
                việc Vi Mô thay đổi biểu phí này (nếu có)).
              </li>
            </ul>
          </div>
          <b style="font-style: italic">ĐIỀU 5. QUYỀN VÀ TRÁCH NHIỆM CỦA VI MÔ</b>
          <div style="padding-left: 50px">
            <p class="txt-bold">1. Quyền của VI MÔ:</p>
            <ul class="custom-list">
              <li>
                Được quyền thu phí cho việc cung cấp dịch vụ thanh toán qua mã VietQR và các khoản
                phí khác theo quy định tại Điều 3.
              </li>
              <li>
                Yêu cầu Merchant cung cấp thông tin và tài liệu cần thiết trong quá trình sử dụng
                Dịch vụ thanh toán bằng mã VietQR
              </li>
              <li>
                Được quyền từ chối thanh toán, thu hồi một phần hoặc toàn bộ số tiền đã thanh toán
                cho Merchant đối với các hóa đơn giao dịch không thực hiện theo đúng các quy định
                hiện hành của Vi Mô
              </li>
              <li>
                Từ chối thực hiện các yêu cầu đăng ký Dịch vụ thanh toán bằng mã VietQR của Merchant
                tại mPOS trong trường hợp đánh giá Merchant vi phạm các Điều khoản, Điều kiện này và
                Merchant phải chịu hoàn toàn các thiệt hại do vi phạm này gây ra.
              </li>
            </ul>
          </div>

          <div style="padding-left: 50px">
            <p class="txt-bold">2. Trách nhiệm của Vi Mô:</p>
            <ul class="custom-list">
              <li>Cung cấp dịch vụ đăng ký/hủy Dịch vụ thanh toán bằng mã VietQR.</li>
              <li>
                Thanh toán đầy đủ số tiền giao dịch qua mã VietQR cho Merchant đối với các giao dịch
                thành công.
              </li>
              <li>Giữ bí mật các thông tin liên quan đến Merchant theo quy định pháp luật.</li>
              <li>
                Không chịu trách nhiệm đối với các trường hợp do lỗi/quá tải/tấn công hệ thống ngoài
                tầm kiểm soát dẫn đến Merchant không nhận được/nhận được chậm các thông báo trạng
                thái giao dịch thanh toán của Merchant đã đăng ký.
              </li>
            </ul>
          </div>
          <b style="font-style: italic">ĐIỀU 6. SỬA ĐỔI NỘI DUNG ĐIỀU KHOẢN, ĐIỀU KIỆN:</b>
          <div style="padding-left: 40px">
            <ol>
              <li>
                6.1. Vi Mô được quyền thay đổi nội dung Điều khoản, Điều kiện này, thay đổi đặc điểm
                sản phẩm phí sử dụng Dịch vụ thanh toán bằng mã VietQR và Vi Mô có trách nhiệm thông
                báo đến Merchant bằng văn bản thông qua email/kênh portal của Vi Mô hoặc bằng bất cứ
                hình thức nào do Vi Mô quy định từng thời kỳ và công khai đến Merchant.
              </li>
              <li>
                6.2. Những thay đổi này sẽ có hiệu lực vào ngày ghi trên Thông báo. Nếu Merchant
                tiếp tục giữ và sử dụng Dịch vụ thanh toán bằng mã VietQR thì xem như đã chấp nhận
                những thay đổi này.
              </li>
            </ol>
          </div>
          <b style="font-style: italic">ĐIỀU 7. HIỆU LỰC CỦA ĐIỀU KHOẢN, ĐIỀU KIỆN</b>
          <div style="padding-left: 40px">
            <ol>
              <li>
                Điều khoản, Điều kiện này có hiệu lực kể từ ngày Merchant ký Hợp đồng Hợp tác chấp
                nhận thanh toán với Vi Mô và đăng ký Dịch vụ thanh toán bằng mã
              </li>
              <li>
                VietQR qua nền tảng PosApp với Vi Mô và được Vi Mô cung cấp dịch vụ và chỉ chấm dứt
                hiệu lực khi Merchant hủy sử dụng dịch vụ trên nền tảng PosApp và được Vi Mô chấp
                thuận hoặc khi Vi Mô ngừng cung cấp dịch vụ cho Merchant theo Điều khoản, Điều kiện
                này.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/contracts/block/header.vue'
  import moment from 'moment'
  export default {
    components: {
      Header,
    },
    data() {
      return {
        // dataContract: null,
        dataContract: { id: 'abcd1234' },
        loadingBtn: false,
      }
    },
    created() {},
    methods: {
      getDayFormat(timestamp) {
        return `ngày ${moment(timestamp).date()} tháng ${moment(timestamp).month() + 1} năm ${moment(timestamp).year()}`
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>

<style scoped>
  .text-center {
    text-align: center !important;
  }

  .fonsize-18 {
    font-size: 18px;
  }

  ul.custom-list {
    list-style: lower-latin;
  }

  ul.custom-list li {
    font-style: italic;
    text-align: justify;
  }
</style>
